// extracted by mini-css-extract-plugin
module.exports = {"company":"_3qdDLLy8jJlq0PxdB2lVv1","paragraph":"_2rIxb_Z2kFhFb1bS2Tldku","comapniesLogos":"PemWFf8lFTX7IfAyIkIrf","logo":"_2vMbuZCp66JQRNBZAHleb4","row":"_1oVMMHZ40y31gsaLgx6yGP"};